import script from "./MediaDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaDetails.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./MediaDetails.vue?vue&type=style&index=0&id=d052daa8&scoped=true&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-d052daa8"]])

export default __exports__